module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_124-a4ee1f6c00dd2d691882599d8dff17e2.png";